/* =====================================================
   Inspiration-Galerie – planaplana
   Lightbox-Logik, gekapselt in IIFE.
   ===================================================== */

(function () {
  'use strict';

  const lightbox = document.getElementById('pl-insp-lightbox');
  if (!lightbox) return;

  const lbContent = document.getElementById('pl-insp-lb-content');
  const lbClose = lightbox.querySelector('.pl-insp-lb-close');
  const lbPrev = lightbox.querySelector('.pl-insp-lb-prev');
  const lbNext = lightbox.querySelector('.pl-insp-lb-next');

  const thumbs = Array.from(document.querySelectorAll('.pl-insp-thumb'));
  if (thumbs.length === 0) return;

  let currentIndex = 0;

  function orientSVG(orient) {
    if (orient === 'horizontal') {
      return '<svg class="pl-insp-orient" viewBox="0 0 24 24" aria-hidden="true"><line x1="4" y1="10" x2="20" y2="10"/><line x1="4" y1="14" x2="20" y2="14"/></svg>';
    }
    return '<svg class="pl-insp-orient" viewBox="0 0 24 24" aria-hidden="true"><line x1="10" y1="4" x2="10" y2="20"/><line x1="14" y1="4" x2="14" y2="20"/></svg>';
  }

  function escapeAttr(s) {
    return (s || '').replace(/"/g, '&quot;').replace(/</g, '&lt;');
  }

  function escapeHTML(s) {
    return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function renderLightbox(idx) {
    const thumb = thumbs[idx];
    const big = thumb.getAttribute('data-big');
    const color = thumb.getAttribute('data-color') || '';
    const colorHex = thumb.getAttribute('data-color-hex') || '#ccc';
    const foil = thumb.getAttribute('data-foil') || '';
    const orient = thumb.getAttribute('data-orient') || 'horizontal';
    const orientLabel = thumb.getAttribute('data-orient-label') || '';
    const labelOverride = thumb.getAttribute('data-label-override') || '';

    let captionInner;
    if (labelOverride.trim().length > 0) {
      captionInner = `
        <span class="pl-insp-dot" style="background:${escapeAttr(colorHex)}"></span>
        <span>${escapeHTML(labelOverride)}</span>
      `;
    } else {
      captionInner = `
        <span class="pl-insp-dot" style="background:${escapeAttr(colorHex)}"></span>
        <span>${escapeHTML(color)}</span>
        <span class="pl-insp-sep">·</span>
        <span>${escapeHTML(foil)}</span>
        <span class="pl-insp-sep">·</span>
        ${orientSVG(orient)}
        <span>${escapeHTML(orientLabel)}</span>
      `;
    }

    lbContent.innerHTML = `
      <img class="pl-insp-lb-image" src="${escapeAttr(big)}" alt="${escapeAttr(color)} mit ${escapeAttr(foil)}-Prägung, ${escapeAttr(orientLabel)}">
      <div class="pl-insp-lb-caption">${captionInner}</div>
    `;
  }

  // Vorladen angrenzender Bilder, damit Blättern snappy ist
  function preloadNeighbor(delta) {
    const idx = (currentIndex + delta + thumbs.length) % thumbs.length;
    const big = thumbs[idx].getAttribute('data-big');
    if (big) {
      const img = new Image();
      img.src = big;
    }
  }

  function openLightbox(idx) {
    currentIndex = idx;
    renderLightbox(idx);
    lightbox.classList.add('open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    preloadNeighbor(1);
    preloadNeighbor(-1);
  }

  function closeLightbox() {
    lightbox.classList.remove('open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function navigate(delta) {
    currentIndex = (currentIndex + delta + thumbs.length) % thumbs.length;
    renderLightbox(currentIndex);
    preloadNeighbor(delta);
  }

  thumbs.forEach(function (btn, idx) {
    btn.addEventListener('click', function () { openLightbox(idx); });
  });

  lbClose.addEventListener('click', closeLightbox);
  lbPrev.addEventListener('click', function () { navigate(-1); });
  lbNext.addEventListener('click', function () { navigate(1); });

  lightbox.addEventListener('click', function (e) {
    if (e.target === lightbox) closeLightbox();
  });

  document.addEventListener('keydown', function (e) {
    if (!lightbox.classList.contains('open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') navigate(-1);
    if (e.key === 'ArrowRight') navigate(1);
  });

  // Swipe-Navigation auf Touch-Geräten
  let touchStartX = null;
  lightbox.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });

  lightbox.addEventListener('touchend', function (e) {
    if (touchStartX === null) return;
    const touchEndX = e.changedTouches[0].clientX;
    const delta = touchEndX - touchStartX;
    if (Math.abs(delta) > 50) {
      navigate(delta > 0 ? -1 : 1);
    }
    touchStartX = null;
  }, { passive: true });
})();